import { IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonRow, IonText, IonTitle, IonToolbar } from '@ionic/react';
import { business, call, home, phonePortrait, refresh } from 'ionicons/icons';
import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import VehicleDetailsCard from '../../components/assetDetailsCard/AssetDetailsCard';
import { DashboardSelectedTab } from '../../components/dashboardFooter/DashboardFooter';
import DistanceTrackingCard from '../../components/distanceTrackingCard/DistanceTrackingCard';
import JobCardList from '../../components/jobCardList/JobCardList';
import ProfileChip from '../../components/profileChip/ProfileChip';
import TechnicianCommentsCard from '../../components/technicianCommentsCard/TechnicianCommentsCard';
import { RouteNames } from '../../models/routes.model';
import { useAppSelector } from '../../store/hooks';
import { IonPageWrapper } from './ClockingDetailPage.styles';
import { handleClickPhoneNumber } from '../../common/util';
import FieldDetailRow from '../../components/detailRow/FieldDetailRow';

interface IComponentProps {}

const ClockingDetailPage: React.FC<IComponentProps> = () => {
  const { labourClocking } = useAppSelector((state) => state.technicianClocking);
  const { distanceTrackingUserActivated } = useAppSelector((state) => state.settings);
  const jobCardListRef = useRef<React.ElementRef<typeof JobCardList>>(null);
  const history = useHistory();

  useEffect(() => {
    if (!labourClocking?.repairOrder) {
      history.replace({
        pathname: RouteNames.dashboard,
        search: `tab=${DashboardSelectedTab.ClockingSummary}`,
      });
    }
    console.log(labourClocking?.repairOrder?.driver);
  }, [labourClocking?.repairOrder, history]);

  const businessPhone = labourClocking?.repairOrder?.driver?.businessPhone ?? 0;
  const mobilePhone = labourClocking?.repairOrder?.driver?.mobilePhone ?? 0;
  const privatePhone = labourClocking?.repairOrder?.driver?.privatePhone ?? 0;

  return (
    <IonPageWrapper>
      <IonHeader color="lightest">
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonBackButton defaultHref={RouteNames.dashboard} color="secondary" />
          </IonButtons>
          <IonTitle>Clocking Details</IonTitle>
          <ProfileChip slot="end" />
        </IonToolbar>
      </IonHeader>
      <IonContent color="lightest">
        <IonCard>
          <IonCardContent>
            {/* Header */}
            <IonItem lines="none" className="refresh-button">
              <IonButtons slot="end">
                <IonButton onClick={() => jobCardListRef.current?.loadJobsManually()} fill="clear">
                  <IonIcon icon={refresh} slot="icon-only" color="primary" />
                </IonButton>
              </IonButtons>
            </IonItem>
            <IonGrid>
              <IonRow>
                {/* Labour clocking */}
                <IonCol>
                  <IonItem>
                    <IonLabel class="ion-text-nowrap" position="stacked" color="dark">
                      Repair Order
                    </IonLabel>
                    <IonText class="ion-text-nowrap">
                      {labourClocking?.jobData?.branchCode} / {labourClocking?.jobData?.repairOrderNumber}
                    </IonText>
                  </IonItem>
                </IonCol>
                <IonCol>
                  <IonItem>
                    <IonLabel class="ion-text-nowrap" position="stacked" color="dark">
                      Job
                    </IonLabel>
                    <IonText class="ion-text-nowrap">
                      {labourClocking?.jobData?.jobType} / {labourClocking?.jobData?.jobCode}
                    </IonText>
                  </IonItem>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonCardContent>
          <JobCardList ref={jobCardListRef} repairOrder={labourClocking?.repairOrder} />
        </IonCard>
        <IonCard>
          <IonCardContent>
            <IonGrid>
              <IonItem>Driver Information</IonItem>
              <IonRow>
                {/* Driver info */}
                {labourClocking?.repairOrder?.driver?.code && (
                  <IonCol>
                    <IonItem>
                      <IonLabel class="ion-text-nowrap" position="stacked" color="dark">
                        Code
                      </IonLabel>
                      <IonText class="ion-text-nowrap">{labourClocking.repairOrder.driver?.code}</IonText>
                    </IonItem>
                  </IonCol>
                )}
                {labourClocking?.repairOrder?.driver?.name && (
                  <IonCol>
                    <IonItem>
                      <IonLabel class="ion-text-nowrap" position="stacked" color="dark">
                        Name
                      </IonLabel>
                      <IonText class="ion-text-nowrap">{labourClocking.repairOrder.driver?.name}</IonText>
                    </IonItem>
                  </IonCol>
                )}
                {labourClocking?.repairOrder?.driver?.companyName && (
                  <IonCol>
                    <IonItem>
                      <IonLabel class="ion-text-nowrap" position="stacked" color="dark">
                        Company Name
                      </IonLabel>
                      <IonText class="ion-text-nowrap">{labourClocking?.repairOrder?.driver?.companyName}</IonText>
                    </IonItem>
                  </IonCol>
                )}
                {labourClocking?.repairOrder?.driver?.address && (
                  <IonCol size="12">
                    <IonItem>
                      <IonLabel class="ion-text-nowrap" position="stacked" color="dark">
                        Address
                      </IonLabel>
                      <IonText>{labourClocking?.repairOrder?.driver?.address}</IonText>
                    </IonItem>
                  </IonCol>
                )}
              </IonRow>
            </IonGrid>
            <IonGrid>
              <IonItem>Contact Information</IonItem>
              <IonRow>
                <IonCol size="12" className="ion-padding">
                  <IonList lines="none">
                    {labourClocking?.repairOrder?.driver?.mobilePhone && <FieldDetailRow isButton={true} value={mobilePhone} icon={call} labelIcon={phonePortrait} lines={false} onClick={(e, val) => handleClickPhoneNumber(val)} copyToClipboard />}
                    {labourClocking?.repairOrder?.driver?.businessPhone && <FieldDetailRow isButton={true} value={businessPhone} icon={call} labelIcon={business} lines={false} onClick={(e, val) => handleClickPhoneNumber(val)} copyToClipboard />}
                    {labourClocking?.repairOrder?.driver?.privatePhone && <FieldDetailRow isButton={true} value={privatePhone} icon={call} labelIcon={home} lines={false} onClick={(e, val) => handleClickPhoneNumber(val)} copyToClipboard />}
                  </IonList>
                </IonCol>
              </IonRow>
            </IonGrid>
          </IonCardContent>
        </IonCard>
        {labourClocking?.repairOrder && labourClocking?.jobData && (
          <>
            <VehicleDetailsCard labourClocking={labourClocking} />
            <TechnicianCommentsCard repairOrder={labourClocking.repairOrder} />
          </>
        )}
        {distanceTrackingUserActivated && <DistanceTrackingCard />}
      </IonContent>
    </IonPageWrapper>
  );
};

export default ClockingDetailPage;
